<template>
    <div class="rounded border bg-white">
        <div class="flex justify-between px-2 py-3 handle">
            <div class="flex items-center space-x-3 truncate">
                <button type="button" class="cursor-move focus:outline-none">
                    <svg class="w-5 h-5 text-gray-500 hover:text-gray-900" fill="none" stroke="currentColor"
                         viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path>
                    </svg>
                </button>

                <div class="flex items-center space-x-3 -my-4 h-12 cursor-pointer" @click.native="$emit('toggle', data)">

                    <svg v-if="data.type === 'social_templates'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M12 2c2.717 0 3.056.01 4.122.06 1.065.05 1.79.217 2.428.465.66.254 1.216.598 1.772 1.153a4.908 4.908 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428.047 1.066.06 1.405.06 4.122 0 2.717-.01 3.056-.06 4.122-.05 1.065-.218 1.79-.465 2.428a4.883 4.883 0 0 1-1.153 1.772 4.915 4.915 0 0 1-1.772 1.153c-.637.247-1.363.415-2.428.465-1.066.047-1.405.06-4.122.06-2.717 0-3.056-.01-4.122-.06-1.065-.05-1.79-.218-2.428-.465a4.89 4.89 0 0 1-1.772-1.153 4.904 4.904 0 0 1-1.153-1.772c-.248-.637-.415-1.363-.465-2.428C2.013 15.056 2 14.717 2 12c0-2.717.01-3.056.06-4.122.05-1.066.217-1.79.465-2.428a4.88 4.88 0 0 1 1.153-1.772A4.897 4.897 0 0 1 5.45 2.525c.638-.248 1.362-.415 2.428-.465C8.944 2.013 9.283 2 12 2zm0 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm6.5-.25a1.25 1.25 0 0 0-2.5 0 1.25 1.25 0 0 0 2.5 0zM12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"/></svg>
                    <svg v-else-if="data.type === 'links'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-2.29-2.333A17.9 17.9 0 0 1 8.027 13H4.062a8.008 8.008 0 0 0 5.648 6.667zM10.03 13c.151 2.439.848 4.73 1.97 6.752A15.905 15.905 0 0 0 13.97 13h-3.94zm9.908 0h-3.965a17.9 17.9 0 0 1-1.683 6.667A8.008 8.008 0 0 0 19.938 13zM4.062 11h3.965A17.9 17.9 0 0 1 9.71 4.333 8.008 8.008 0 0 0 4.062 11zm5.969 0h3.938A15.905 15.905 0 0 0 12 4.248 15.905 15.905 0 0 0 10.03 11zm4.259-6.667A17.9 17.9 0 0 1 15.973 11h3.965a8.008 8.008 0 0 0-5.648-6.667z"/></svg>
                    <svg v-else-if="data.type === 'assets'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M21 8v12.993A1 1 0 0 1 20.007 22H3.993A.993.993 0 0 1 3 21.008V2.992C3 2.455 3.449 2 4.002 2h10.995L21 8zm-2 1h-5V4H5v16h14V9zM8 7h3v2H8V7zm0 4h8v2H8v-2zm0 4h8v2H8v-2z"/></svg>
                    <svg v-else-if="data.type === 'banners'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M5 11.1l2-2 5.5 5.5 3.5-3.5 3 3V5H5v6.1zm0 2.829V19h3.1l2.986-2.985L7 11.929l-2 2zM10.929 19H19v-2.071l-3-3L10.929 19zM4 3h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm11.5 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/></svg>
                    <svg v-else-if="data.type === 'accordion'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M3 4h18v2H3V4zm0 7h18v2H3v-2zm0 7h18v2H3v-2z"/></svg>
                    <svg v-else-if="data.type === 'colors'" class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path d="M12 2c5.522 0 10 3.978 10 8.889a5.558 5.558 0 0 1-5.556 5.555h-1.966c-.922 0-1.667.745-1.667 1.667 0 .422.167.811.422 1.1.267.3.434.689.434 1.122C13.667 21.256 12.9 22 12 22 6.478 22 2 17.522 2 12S6.478 2 12 2zm-1.189 16.111a3.664 3.664 0 0 1 3.667-3.667h1.966A3.558 3.558 0 0 0 20 10.89C20 7.139 16.468 4 12 4a8 8 0 0 0-.676 15.972 3.648 3.648 0 0 1-.513-1.86zM7.5 12a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM12 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/></svg>
                    <svg v-else-if="data.type === 'videos'" class="w-5 h-5 text-gray-900" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M3 3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44495 21 3.9934V20.0066C21 20.5552 20.5551 21 20.0066 21H3.9934C3.44476 21 3 20.5551 3 20.0066V3.9934ZM5 5V19H19V5H5ZM10.6219 8.41459L15.5008 11.6672C15.6846 11.7897 15.7343 12.0381 15.6117 12.2219C15.5824 12.2658 15.5447 12.3035 15.5008 12.3328L10.6219 15.5854C10.4381 15.708 10.1897 15.6583 10.0672 15.4745C10.0234 15.4088 10 15.3316 10 15.2526V8.74741C10 8.52649 10.1791 8.34741 10.4 8.34741C10.479 8.34741 10.5562 8.37078 10.6219 8.41459Z"></path></svg>
                    <svg v-else-if="data.type === 'embed'" class="w-5 h-5 text-gray-900" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"/></svg>
                    <svg v-else class="w-5 h-5 text-gray-900" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"></path><path d="M13 6v15h-2V6H5V4h14v2z"></path></svg>

                    <span class="text-sm text-gray-900 truncate max-w-96">
                        {{ data.title }}
                        <span v-if="!data.title" class="text-gray-500">
                            <template v-if="data.type === 'social_templates'">Social media templates</template>
                            <template v-if="data.type === 'accordion'">Accordion</template>
                            <template v-if="data.type === 'assets'">Assets</template>
                            <template v-if="data.type === 'banners'">Banners</template>
                            <template v-if="data.type === 'links'">Links</template>
                            <template v-if="data.type === 'colors'">Colors</template>
                            <template v-if="data.type === 'videos'">Video</template>
                            <template v-if="data.type === 'embed'">Embed code</template>
                        </span>
                    </span>

                </div>
            </div>
            <div class="flex space-x-2">
                <button type="button" class="focus:outline-none" @click.native="$emit('remove', data)"
                        v-if="!data.protected">
                    <svg class="w-5 h-5 text-gray-500 hover:text-red-600" fill="currentColor"
                         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                        <path fill="none" d="M0 0h24v24H0z"/>
                        <path
                            d="M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3zm1 2H6v12h12V8zm-9 3h2v6H9v-6zm4 0h2v6h-2v-6zM9 4v2h6V4H9z"/>
                    </svg>
                </button>
                <button type="button" class="focus:outline-none" @click.native="$emit('toggle', data)">
                    <svg class="w-5 h-5 text-gray-500 hover:text-gray-900"
                         v-bind:class="{ 'text-teal-600 hover:text-teal-700': data.edit }" fill="currentColor"
                         xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                        <path fill="none" d="M0 0h24v24H0z"/>
                        <path
                            d="M3.34 17a10.018 10.018 0 0 1-.978-2.326 3 3 0 0 0 .002-5.347A9.99 9.99 0 0 1 4.865 4.99a3 3 0 0 0 4.631-2.674 9.99 9.99 0 0 1 5.007.002 3 3 0 0 0 4.632 2.672c.579.59 1.093 1.261 1.525 2.01.433.749.757 1.53.978 2.326a3 3 0 0 0-.002 5.347 9.99 9.99 0 0 1-2.501 4.337 3 3 0 0 0-4.631 2.674 9.99 9.99 0 0 1-5.007-.002 3 3 0 0 0-4.632-2.672A10.018 10.018 0 0 1 3.34 17zm5.66.196a4.993 4.993 0 0 1 2.25 2.77c.499.047 1 .048 1.499.001A4.993 4.993 0 0 1 15 17.197a4.993 4.993 0 0 1 3.525-.565c.29-.408.54-.843.748-1.298A4.993 4.993 0 0 1 18 12c0-1.26.47-2.437 1.273-3.334a8.126 8.126 0 0 0-.75-1.298A4.993 4.993 0 0 1 15 6.804a4.993 4.993 0 0 1-2.25-2.77c-.499-.047-1-.048-1.499-.001A4.993 4.993 0 0 1 9 6.803a4.993 4.993 0 0 1-3.525.565 7.99 7.99 0 0 0-.748 1.298A4.993 4.993 0 0 1 6 12c0 1.26-.47 2.437-1.273 3.334a8.126 8.126 0 0 0 .75 1.298A4.993 4.993 0 0 1 9 17.196zM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                    </svg>
                </button>
            </div>
        </div>

        <div class="py-6 px-6 bg-gray-50 bg-opacity-75 border-t space-y-4" v-if="data.edit">

            <div v-if="data.type === 'embed'">
                <Embed :data="data" :show-section-toggle="true"></Embed>
            </div>

            <div v-else class="space-y-4">

                <text-field
                    label="Title"
                    v-model="data.title"
                />

                <div>
                    <div class="flex items-center justify-between mb-1.5">
                        <label class="text-sm">Icon (optional)</label>
                        <div v-if="data.icon?.url || data.icon?.path" class="flex items-center gap-3">
                            <div class="flex items-center">
                                <span class="text-xs text-gray-400 mr-1">Size:</span>
                                <select
                                    v-model="data.icon_size"
                                    class="border-0 focus:ring-0 leading-4 text-xs text-gray-500 p-0 pr-6 bg-transparent cursor-pointer"
                                >
                                    <option value="small">Small</option>
                                    <option value="medium">Medium</option>
                                    <option value="large">Large</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <FileUpload
                        :data="data.icon"
                        :options="options"
                        :unique_id="unique_id"
                        accept="image/*"
                        title="Icon"
                        name="resource_icon"
                        size="compact"
                        no_src="/images/upload-image.png"
                    ></FileUpload>
                </div>

                <text-editor
                    :text="data.description"
                    @input="(newValue) => { data.description = newValue }"
                />

                <div>
                    <label class="flex justify-between items-center mb-1.5 text-sm"> Content </label>

                    <div v-if="data.type === 'assets'">
                        <Assets :data="data" :options="options" :unique_id="unique_id"></Assets>
                    </div>

                    <div v-if="data.type === 'accordion'">
                        <Accordion :data="data" :options="options" :unique_id="unique_id"></Accordion>
                    </div>

                    <div v-if="data.type === 'links'">
                        <Links :data="data" :options="options" :unique_id="unique_id"></Links>
                    </div>

                    <div v-if="data.type === 'banners'">
                        <Banners :data="data" :options="options" :unique_id="unique_id"></Banners>
                    </div>

                    <div v-if="data.type === 'colors'">
                        <Colors :data="data" :options="options" :unique_id="unique_id"></Colors>
                    </div>

                    <div v-if="data.type === 'videos'">
                        <Videos :data="data" :options="options" :unique_id="unique_id"></Videos>
                    </div>

                    <div v-if="data.type === 'social_templates'">
                        <SocialTemplates :data="data" :options="options" :unique_id="unique_id"></SocialTemplates>
                    </div>

                </div>

            </div>

            <!-- Visibility settings - shown for all resource types -->
            <div v-if="options.available_partner_tags && options.available_partner_tags.length > 0" class="flex justify-between items-start">
                <toggle
                    size="medium"
                    @update:model-value="data.visibility = $event ? 'tags' : 'all'"
                    :model-value="data.visibility === 'tags'"
                >
                </toggle>
                <span class="flex flex-col flex-grow">
                    <span class="text-sm font-medium">Limit visibility by partner tags</span>
                    <span class="text-sm text-gray-500">Only show this resource to partners with specific tags.</span>
                    <div v-if="data.visibility === 'tags'" class="flex flex-wrap gap-1.5 mt-2.5">
                        <button
                            v-for="tag in options.available_partner_tags"
                            :key="tag.key"
                            type="button"
                            @click="toggleVisibilityTag(tag.key)"
                            class="inline-flex items-center gap-1 text-xs font-medium rounded-full px-2.5 py-1 transition-colors focus:outline-none"
                            :class="isVisibilityTagSelected(tag.key)
                                ? 'bg-teal-500 hover:bg-teal-600 text-white'
                                : 'bg-gray-100 hover:bg-gray-200 text-gray-700'"
                        >
                            <svg v-if="isVisibilityTagSelected(tag.key)" class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                            </svg>
                            <span>{{ tag.value }}</span>
                        </button>
                    </div>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import Banners from './Res/Banners.vue'
import Assets from './Res/Assets.vue'
import Links from './Res/Links.vue'
import Accordion from './Res/Accordion.vue'
import Colors from './Res/Colors.vue'
import {BubbleMenu, FloatingMenu,} from '@tiptap/vue-3'
import Videos from './Res/Videos.vue'
import SocialTemplates from './Res/SocialTemplates.vue'
import FileUpload from './Res/includes/FileUpload.vue'
import Embed from '../resources-builder/resources/Embed.vue'

export default {
    props: ['data', 'options', 'unique_id'],
    emits: ['remove', 'toggle'],
    components: {
        Assets,
        Banners,
        Links,
        Accordion,
        Colors,
        BubbleMenu,
        FloatingMenu,
        Videos,
        SocialTemplates,
        FileUpload,
        Embed,
    },
    methods: {
        toggleVisibilityTag(tagKey) {
            if (!this.data.visibility_tags) {
                this.data.visibility_tags = [];
            }
            const index = this.data.visibility_tags.indexOf(tagKey);
            if (index === -1) {
                this.data.visibility_tags.push(tagKey);
            } else {
                this.data.visibility_tags.splice(index, 1);
            }
        },
        isVisibilityTagSelected(tagKey) {
            return (this.data.visibility_tags || []).includes(tagKey);
        },
    },
    created() {
        this.data.unique_id = this.unique_id;
        // Initialize icon object if not present
        if (!this.data.icon) {
            this.data.icon = {};
        }
        // Initialize settings with default values
        if (!this.data.icon_size) {
            this.data.icon_size = 'medium';
        }
        if (!this.data.alignment) {
            this.data.alignment = 'left';
        }
        // Initialize visibility settings
        if (!this.data.visibility) {
            this.data.visibility = 'all';
        }
        if (!this.data.visibility_tags) {
            this.data.visibility_tags = [];
        }
    }
}
</script>

<style lang="scss">
.ProseMirror {
    min-height: 70px;

    > * + * {
        margin-top: 0.75em;
    }

    ul,
    ol {
        padding: 0 1rem;
    }

    blockquote {
        padding-left: 1rem;
        border-left: 2px solid rgba(#0D0D0D, 0.1);
    }

    &:focus, &:active {
        outline: none;
    }

    h1 {
        font-weight: 600;
        font-size: 1.25rem;
        line-height: 1.75rem;
    }

    h2 {
        font-weight: 600;
        font-size: 1.125rem;
        line-height: 1.75rem;
    }
}

.tiptap-menu {
    display: flex;

    button {
        border: none;
        background: none;
        color: #FFF;
        font-size: 0.85rem;
        font-weight: 500;
        padding: 0 0.4rem;
        opacity: 0.6;

        &:focus, &:active {
            outline: none;
        }

        &:hover,
        &.is-active {
            opacity: 1;
        }
    }
}

.floating-menu {
    display: flex;
    background-color: #111827;
    padding: 0.2rem;
    border-radius: 0.5rem;

    button {
        border: none;
        background: none;
        font-size: 0.85rem;
        font-weight: 500;
        padding: 0 0.2rem;
        opacity: 0.6;

        &:hover,
        &.is-active {
            opacity: 1;
        }
    }
}
</style>
